/**
 * 出货订单管理- 预计出货订单详情
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 */
import React from 'react';
import AutoFetchList from '@components/AutoFetchList/AutoFetchList';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import PicturePreview from '@components/PicturePreview/PicturePreview';
import {Spin, Row, Col, Space, Button, Input, Divider, Dropdown, Card, message, Badge, Select} from 'antd';
import Lang from "@components/Lang/Lang";
import {isEmpty} from '@utils/utils';
import { toFixedWithCommas} from "@utils/number-util";
import "./Detail.less";
import ShipperManagementAction from "../../ShipperManagement.action";
import {DownCircleOutlined} from "@ant-design/icons";
import StickerPicturePreview from '../../component/StickerPicturePreview';
import {
    ClockCircleFilled,CheckCircleFilled, InfoCircleFilled
} from '@ant-design/icons';
const { Search } = Input;
const Option = Select.Option;

class EstimatedShippingOrderDetail extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            list: [],
            model:{},
            query:{},//查询参数
        }
    }
    /**
     * 查看详情
     * */
    getDetail(sId){
        this.loading(true);
        const postData = {
            containerId:sId,
        }
        ShipperManagementAction.getContainerOrderTop(postData).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
    }
    handleRes(res){
        this.loading(false);
        const {success,valid,model} = res;
        if(success&&valid){
            this.setState({
                model: model||{},
            })
        }else if(res.message)message.warning(res.message);
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    getCerId(str){
        let iId = str.length>0?str.substr(1,str.length):'';
        iId = iId?Number(iId):'';
        this.setState({
            iId: iId
        })
        return iId;
    }
    /**
     * 渲染列表
     * @list 数据源
     * @type 编辑类型 edit 可编辑 view 查看状态，不可编辑
     * @certDict 证书类型
     * **/
     renderList = (item,inx,containerId) =>{
        return(<div className={'itemLi'} key={inx}>
            <div className={'top'}>
                <div className={'title'}>
                    <Dropdown overlayClassName='comment-scrollbar' dropdownRender={(menu) =>this.showPhoneList()} trigger={['click']}>
                        <a className="font-blue" onClick={()=>this.getPhoneList(item,containerId)}>
                            {item.buyerCode}<DownCircleOutlined />
                        </a>
                    </Dropdown>
                </div>
                <div className={'subtitle'}>
                    <Space size={'small'}>
                        <span>{Lang({id: 'KuanShu', default: '款数'})}</span>
                        <span className="txt">{item.skuCount||'-'}</span><Divider type="vertical" />
                        <span>{Lang({id: 'XiangShu', default: '箱数'})}</span>
                        <span className="txt">{item.quantity||'-'}</span><Divider type="vertical" />
                        <span>{Lang({id: 'TiJi', default: '体积'})}</span>
                        <span className="txt">{toFixedWithCommas(item.totalVolume,3)||'-'} m³</span>
                    </Space>
                </div>
            </div>
            {item.poList&&item.poList.length>0&&this.renderPoList(item.poList)}
        </div>)
    }
    renderPoList(list=[]){
        let children = [];
        list.forEach((item,inx)=>{
            children.push(<div className={'poLi'} key={inx}>
                <div className={'poCodeTile'}>
                    <span className={'code'}>{item.poCode}</span>
                    {/*<a onClick={()=>this.viewStickerPictures(item)}>{Lang({id: 'ChaKanTieZhiPaiBanTu', default: '查看贴纸排版图'})}</a>*/}
                    {item.hasOldStickerLayout==1?<StickerPicturePreview item={item} loading={flag=>this.loading(flag)} />:null}
                </div>
                {item.skuList&&item.skuList.map((sku,inx) => (<div className={'skuLi'} key={inx}>
                    <div className={'thumbnailWrap'}>
                        {sku.skuPictureUrl&&<img src={sku.skuPictureUrl} />}
                        <div className={'skuNo'}>{Lang({id: 'ShangPinBianMa2', default: '商品编码2'})}<span>{sku.skuNo}</span></div>
                    </div>
                    <div className={'info'}>
                        <h4>{sku.skuName}</h4>
                        <Row className={'infoDetail'}>
                            <Col>{Lang({id: 'DanJia', default:'单价'})}<span>{item.currencySymbol}&nbsp;{sku.price}</span></Col>
                            <Col offset={1}>{Lang({id: 'XiangShu', default:'箱数'})}<span>{sku.quantity}</span></Col>
                            <Col offset={1}>{Lang({id: 'JinE', default:'金额'})}<span>{item.currencySymbol}&nbsp;{sku.priceTotal}</span></Col>
                        </Row>
                        <div className={'attributeDetail'}>
                            <p className={'nameProduct'}>
                                {/*{Lang({id: 'TieZhiPinMing', default: '贴纸品名'})}*/}
                           {sku.skuNameRu}</p>
                            <div className={'attList'}>
                            {this.renderAttribute(sku.attributeList,sku.customsCode,sku.mainMaterials)}
                            </div>
                        </div>
                        <div className={'picList'}>
                            <Space>
                                {/*  todo 对接*/}
                               <PicturePreview list={sku.stickerLayoutPicList} moreNum={4} title={Lang({id: 'TieZhiPaiBanTu', default: '贴纸排版图'})} />
                               <PicturePreview list={sku.goodsPicList} moreNum={4} title={Lang({id: 'BaoZhuangLiuMianTu', default: '包装六面图'})} />
                               <PicturePreview list={sku.qualityTestPicList} moreNum={4} title={<div>
                                   {sku.qualityTestPicStatus==0&&<ClockCircleFilled style={{color: '#03a9f4'}} />}
                                   {sku.qualityTestPicStatus==1&&<CheckCircleFilled style={{color: '#52c41a'}} />}
                                   {sku.qualityTestPicStatus==2&&<InfoCircleFilled style={{color: '#f00'}}/>}
                                   <span className={"margin-let-3"}>{Lang({id: 'ZhiJianTuPian', default: '质检图片'})}</span></div>} />
                            </Space>
                        </div>
                    </div>
                </div>))}

            </div>)
        });
        return children;
    }
    // 属性列表
    renderAttribute(attributeList=[],customsCode='',mainMaterials=''){
        let childAtt = [];
        if(!isEmpty(customsCode)){
            childAtt.push(<div key={'customsCode'} className={'descItem'}>
                {Lang({id: 'HaiGuanBianMa', default: '海关编码'})}<span>{customsCode}</span>
            </div>)
        }
        attributeList.forEach((att,inx)=>{
            if(att.optionList&&att.optionList.length>0)childAtt.push(<div  key={inx} className={'descItem'}>{att.attributeName}{att.optionList&&att.optionList.map((item, suInx)=>(<span key={suInx}>{item.optionName}</span>))}</div>)
        })
        if(!isEmpty(mainMaterials)){
            childAtt.push(<div key={'mainMaterials'} className={'descItem'}>
                {Lang({id: 'CaiZhi', default: '材质'})}<span>{mainMaterials}</span>
            </div>)
        }
        return childAtt;
    }
    /**
     * 联系人信息列表
     * */
    getPhoneList(data,containerId){
        const postData = {
            buyerId: data.buyerId,
            containerId: containerId,
        }
        ShipperManagementAction.getPurchaserInfo(postData).then(res=>this.handlePhoneListRes(res.data)).catch(err=>this.handlePhoneListRes(err))
    }
    handlePhoneListRes(res){
        const {success,valid,models,} = res;
        if(success&&valid){
            this.setState({
                phoneList:models||[],
            })
        }else {
            if(res.message)message.error(res.message);
            this.setState({
                phoneList:models||[],
            })
        }
    }
    showPhoneList = ()=>{
        const {phoneList=[]} = this.state;
         return ( <div>
                 <Card title={Lang({id: 'LianXiRenXinXi', default: "联系人信息"})}
                       bordered={false}
                       bodyStyle={{padding: '16px 24px 24px', maxHeight: '380px', overflowY:'auto'}}
                       style={{ width: '520px', }}>
                     {!phoneList.length && <Spin />}
                     {
                         phoneList.map((item, index) => (
                             <div className="card-phone-item test" key={index.toString()}>
                                 <p data-flex="cross:center" className="mb_10">
                                     <i className="iconfont icon-essa-hd-me mr_12" style={{color: '#646A73', fontSize: '18px'}}></i>
                                     <span className="item-txt-1 mr_34">{item.type==0?Lang({id: 'XiaDanRen', default: '下单人'}):Lang({id: 'ShouHuoRen', default: '收货人'})}</span>
                                     <span className="item-txt-2 flex1">{item.name}</span>
                                 </p>
                                 <p data-flex="cross:center" className="">
                                     <i className="iconfont icon-dianhua mr_12" style={{color: '#646A73', fontSize: '18px'}}></i>
                                     <span className="item-txt-1 mr_16">{Lang({id: 'ShouJiHaoMao', default: '手机号码'})}</span>
                                     <span className="item-txt-2 flex1">{item.mobile}</span>
                                 </p>
                             </div>
                         ))
                     }
                 </Card>
             </div>
         )
    }
    /**
     * 下载六面图
     * type: 'GoodsPic ：六面圖 ，  'QualityPic'：质检图片，
     * */
    downloadPic(containerId,sType=''){
        this.loading(true);
        const postData = {
            containerId:containerId,
        }
        // const type = 'GoodsPic';//type: 'GoodsPic ：六面圖 ，  'QualityPic'：质检图片，
        ShipperManagementAction.downloadPic(postData,sType).then(res=>this.handleDownLoadRes(res.data,containerId,sType)).catch(err=>this.handleDownLoadRes(err));
    }
    /**
     * 下載回調
     * type: 'GoodsPic ：六面圖 ，  'QualityPic'：质检图片，
     * */
    handleDownLoadRes(res={},containerId='',type=''){
        this.loading(false);
        const {success,valid,resultCode, model} = res;
        if(success&&valid){
            if(resultCode=='isEmpty'){ // isEmpty    没有图片  不要打开新tap页下载
                message.warning(Lang({id:'ZanWeiShangChuan',default: '暂未上传'}));
            }else if(model&&model.viewName){
                window.open(model.viewName);
            }else{
                window.open(`/act/shipperManagement/downloading?id=${containerId}&type=${type}`,'_blank')
            }
        }else if(res.message)message.warning(res.message);
    }
    // 列表
    onRefAutoFetchList = (ref) =>  this.onRefAutoFetchListChrld = ref;
    onSearch(value, field){
        const { query } =this.state;
        let newQuery = {...query};
        if(isEmpty(value)){
            delete newQuery[field];
        }else newQuery[field] = value;

        this.setState({
            query: newQuery
        })
        this.onRefAutoFetchListChrld.handleFetch(1,false,newQuery)
    }
    // 状态筛选列表
    onSelectSearch(value){
        const { query } =this.state;
        let newQuery = {...query};
        if(isEmpty(value)){
            delete newQuery.qualityPicStatus;
        }else newQuery['qualityPicStatus'] = Number(value);
        this.setState({
            query: newQuery
        })
        this.onRefAutoFetchListChrld.handleFetch(1,false,newQuery)
    }
    // 跳转
    goPage(qualityTestPicCount=0,sUrl){
        if(qualityTestPicCount>0){
            this.props.history.push(sUrl);
        }else message.info(Lang({id:'MeiYouShuJu',default: "没有数据"}));
    }
    componentDidMount() {
        const { search } = this.props.location;
        const sId = this.getCerId(search);
        this.getDetail(sId);
    }
    componentWillUnmount(){
    }
    render(){
        const { loading,model,iId, } = this.state;
        const currPageName = Lang({id: "YuJiChuHuoDingDan",default: "预计出货订单"});
        return (<Spin tip='loading' spinning={loading}>
            <CommonBreadcrumb list={[{ name:currPageName,link:'/shipperManagement/estimatedShippingOrder/list'},{name:Lang({id: "YuJiChuHuoDingDanXiangQing",default: "预计出货订单详情"})}]}></CommonBreadcrumb>
            <div className="estimatedShippingOrderDetailStyle">
                <div className={'topInfo'}>
                    <p className={'title'}>{currPageName}<span>{model.containerCode}</span></p>
                    <p className={'subtitle'}>{Lang({id: "DingDanQingDan",default: "订单清单"})}</p>
                    <p className={'totalTitle'}> {Lang({id:'ZongGong',default:'总共'})}
                        <span>{model.skuCount||0}</span>
                        {Lang({id:'Kuan', default:'款'})}，
                        <span>{model.quantity||0}</span>
                        {Lang({id:'Xiang',default:'箱'})} , {Lang({id: 'ZongTiJi', default: '总体积',})}: <span>{toFixedWithCommas(model.totalVolume,3)||'-'}</span>m³
                    </p>
                    <div className={'downloadRow'}>
                        <Row>
                            <Col span={16}>
                                <Button onClick={()=>this.downloadPic(model.containerId,'GoodsPic')}>{Lang({id: "XiaZaiLiuMianTu",default: "下载六面图"})}</Button>
                                <Button onClick={()=>this.downloadPic(model.containerId,'QualityPic')}>{Lang({id: "XiaZaiZhiJianTuPian",default: "下载质检图片"})}</Button>
                                <Button onClick={()=>this.goPage(model.qualityTestPicCount,'/shipperManagement/checkQualityPictures?'+iId)}>
                                    {Lang({id: "JianChaZhiJianTuPian",default: "检查质检图片"})}
                                    <Badge showZero count={model.qualityTestPicCount&&model.qualityTestPicCount>0?model.qualityTestPicCount:0} offset={[2, -3]} overflowCount={999} />
                                </Button>
                            </Col>
                            <Col span={8}>
                                <Select placeholder={Lang({id:'QuanBuZhuangTai2',default:'全部状态'})} style={{ width: "30%" }}
                                        onChange={(value)=>{this.onSelectSearch(value,'qualityPicStatus')}}
                                        allowClear={true}>
                                    <Option value="2">{Lang({id:'ZhiJianYouWenTi',default:'质检有问题'})}</Option>
                                    <Option value="1">{Lang({id:'ZhiJianMeiWenTi',default:'质检没问题'})}</Option>
                                    <Option value="0">{Lang({id:'ZhiJianDaiChuLi',default:'质检待处理'})}</Option>
                                </Select>
                                <Search
                                    placeholder={ Lang({id: "QingShuRuKeHuBianMaHuoShangBinBianMa",default: "请输入客户编码或商品编码",})}
                                    style={{ width: "70%" }}
                                    loading={loading}
                                    allowClear={true}
                                    onSearch={(value, event)=>this.onSearch(value, 'keyword')} />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className={'itemList'}>
                    {!isEmpty(iId)&&<AutoFetchList onRef={this.onRefAutoFetchList}
                                                   showTotal={false}
                                                   precondition={{containerId:iId}}
                                                   fetchApi={'/service/mg/container/orderDetails'} //http://rap.essa.top:88/workspace/myWorkspace.do?projectId=239#6849
                                                   renderList={(item,inx)=>this.renderList(item,inx,iId)} />}

                </div>
            </div>
        </Spin>)
    }
}
export default EstimatedShippingOrderDetail;